module.exports = __webpack_public_path__ + "static/img/moreFunction5.2717a05.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/moreFunction5.webp
// module id = Ygb3
// module chunks = 2